// Copyright (c) 2021 WiseTime. All rights reserved.

import { Action } from "redux"
import { Observable } from "rxjs"
import { filter, map, tap } from "rxjs/operators"
import * as Actions from "../actions"
import { getAddTeamPath } from "app/routing"

export const redirectToPage = (): void =>
  window.location.replace(getAddTeamPath())

export const redirectToAddTeam = (
  redirectToPage: () => void
) => (action$: Observable<Action>): Observable<Action> =>
  action$.pipe(
    filter(Actions.redirectToAddTeam.match),
    tap(_ => redirectToPage()),
    map(_ => Actions.redirectToAddTeamDone()),
  )

export default redirectToAddTeam(redirectToPage)
